@let validPercent = screeningSummaryData().validPercent;
@let isAllValid = screeningSummaryData().isAllValid;
@let unknownCount = screeningSummaryData().unknownCount;
@let validXofY = screeningSummaryData().validXofY;
@let maybeValidXofY = screeningSummaryData().maybeValidXofY;
@let screeningStatus = screeningSummaryData().screeningStatus;

<rt-collapsible-card
  [uniqKey]="`screening-with-ai-${screening().id}`"
  [collapsed]="initialCollapsed()"
  [hasHeaderDivider]="true"
  [hasLeftSlotDesc]="true"
  [collapseDisabled]="forceCollapsed()"
  [forceCollapsed]="forceCollapsed()"
>
  <ng-container leftSlot>
    @if (hasNewBadge()) {
      <rt-badge color="pink-gradient" [text]="'app.common.new' | translate" margin-right-small-x />
    }

    <rt-heading>
      {{ 'app.ai_candidate_screening.results.ai_screening' | translate }}
    </rt-heading>
  </ng-container>
  <ng-container bellowLeftSlot>
    <div class="description">
      @if (offer(); as offerVal) {
        <rt-offer-status-indicator [offerStatus]="offerVal" margin-right-small-xx />
        <rt-truncate
          #truncateCmp
          [rtTooltip]="offerVal.title"
          [rtTooltipEnabled]="truncateCmp.isTruncated()"
          class="offer-title"
        >
          {{ offerVal.title }}
        </rt-truncate>
        <rt-divider variant="dot" />
      }
      @if (screeningStatus === 'failed') {
        {{ 'app.ai_candidate_screening.results.no_data' | translate }}
      } @else if (screeningStatus === 'pending' || screeningStatus === 'in_progress') {
        {{ 'app.ai_candidate_screening.results.checking_criteria' | translate }}
      } @else if (isAllValid) {
        {{ 'app.ai_candidate_screening.results.all_criteria_met' | translate }}
      } @else {
        @let validText =
          (unknownCount === 0
            ? 'app.ai_candidate_screening.results.x_of_y_criteria_met'
            : 'app.ai_candidate_screening.results.x_of_y_criteria_met_z_unknown'
          ) | translate: { XofY: validXofY, unknownCount: unknownCount };
        <span
          #elRef
          class="text-ellipsis"
          [rtTooltip]="validText"
          [rtTooltipEnabled]="elRef.offsetWidth < elRef.scrollWidth"
        >
          {{ validText }}
        </span>
      }
    </div>
  </ng-container>
  <ng-container rightSlot>
    <div class="status">
      @if (screeningStatus === 'failed') {
        <rt-icon name="help-filled" colorToken="colorIconLowDisabled" size="medium" />
        <span text-weight-default>
          {{ 'app.ai_candidate_screening.results.unknown' | translate }}
        </span>
      } @else if (screeningStatus === 'pending' || screeningStatus === 'in_progress') {
        <rt-icon name="ai" />
        <span text-weight-default>
          {{ 'app.ai_candidate_screening.results.screening' | translate }}
        </span>
      } @else if (screeningStatus === 'completed') {
        <rt-screening-icon [fillAmount]="validPercent" />
        <span [class.valid]="isAllValid">
          {{ maybeValidXofY }}
        </span>
      }
    </div>
  </ng-container>
  <ng-container collapsible>
    <div padding-tb-small padding-lr-medium>
      <rt-ai-screening-results-list
        [screening]="screening()"
        [disableEdit]="disableEdit()"
        [expandable]="true"
        (edit)="edit.emit($event)"
      />
    </div>
  </ng-container>
</rt-collapsible-card>
